import React from 'react';
import { string, number, func, object } from 'prop-types';

// Import components
import { AuthModal, CommonButton } from 'components/elements';

// Import logic
import usePlayButton from './usePlayButton';

const PlayButton = ({ width, redirect, ...restProps }) => {
	const { linkRedirect, buttonText, isAvailableToPlay, opacity, renderAs } =
		usePlayButton(restProps);

	return (
		<AuthModal>
			<CommonButton
				isPrime={isAvailableToPlay}
				as={renderAs}
				onClick={redirect}
				width={width}
				to={linkRedirect}
				isDisabled={!isAvailableToPlay}
				style={{ opacity }}
			>
				{buttonText}
			</CommonButton>
		</AuthModal>
	);
};

PlayButton.defaultProps = {
	width: 144,
	subtype: '',
	uuid: '',
	redirect: () => {},
	product: {}
};

PlayButton.propTypes = {
	uuid: string,
	width: number,
	subtype: string,
	redirect: func,
	product: object.isRequired
};

export default PlayButton;
